import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/portal/Login";
import { PortalLayout } from "@/components/portal/PortalLayout";
import Dashboard from "@/pages/portal/Dashboard";
import Planner from "@/pages/portal/Planner";
import Clients from "@/pages/portal/Clients";
import ClientDetail from "@/pages/portal/ClientDetail";
import ServicesCatalog from "@/pages/portal/ServicesCatalog";
import Invoices from "@/pages/portal/Invoices";
import Receipts from "@/pages/portal/Receipts";
import Incidents from "@/pages/portal/Incidents";
import FamilyDashboard from "@/pages/portal/FamilyDashboard";
import { PaymentSuccess, PaymentCancel } from "@/pages/portal/PaymentResult";
import { Loader2 } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-sand">
        <Loader2 className="h-8 w-8 animate-spin text-sage" />
      </div>
    );
  if (!user) return <Navigate to="/portal/login" replace />;
  return children;
}

function PortalIndex() {
  const { user } = useAuth();
  return <Navigate to={user?.role === "admin" ? "/portal/dashboard" : "/portal/family"} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/portal/login" element={<Login />} />
          <Route
            path="/portal/payment/success"
            element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>}
          />
          <Route
            path="/portal/payment/cancel"
            element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>}
          />
          <Route
            path="/portal"
            element={
              <ProtectedRoute>
                <PortalLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<PortalIndex />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="planner" element={<Planner />} />
            <Route path="clients" element={<Clients />} />
            <Route path="clients/:id" element={<ClientDetail />} />
            <Route path="services" element={<ServicesCatalog />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="receipts" element={<Receipts />} />
            <Route path="incidents" element={<Incidents />} />
            <Route path="family" element={<FamilyDashboard />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
